/**
 * Turbulence model
 */
export class TurbulenceModel {

    minAlt: string;

    maxAlt: string;

    intensity: string;

    /**
     * Parses sky condition from API
     * @param minAlt string
     * @param maxAlt string
     * @param intensity string
     * @returns {TurbulenceModel} turbulence layer
     */
    static parse(minAlt, maxAlt, intensity): TurbulenceModel {
        return {
            minAlt,
            maxAlt,
            intensity
        };
    }
}
